<!-- Actions for Group List page -->
<template>
	<div>
		<div v-if="this.user_role !== 'guest'" class="text-center mt-1">
			<vx-tooltip :text="'View'" position="bottom" class="inline-flex">
				<feather-icon icon="EyeIcon" :svgClasses="`h-4 w-4 cursor-pointer`" @click="viewActivity()" />
			</vx-tooltip>
		</div>
	</div>	
</template>

<script>
	
	 export default {
	 	name: 'CellRendererViewActions',
    computed: {
			user_role(){
      	return JSON.parse(localStorage.getItem("userDetails")).role;
			} 
		},
		methods: {
			viewActivity(){				
				var rowData = this.params.rowData;
				var triggerEvent = this.params.triggerEvent;
				
				this.$root.$emit(triggerEvent, rowData);
			}
		},
	}
</script>
<style>
    .disabled{
		pointer-events: none;
        opacity: 0.4;
	}
</style>